import { IProps } from '../Render';

import { secondToHHMMSS } from '../utils/Time';

interface IEditArgs {
    audioAction: 'add' | 'remove' | 'get' | 'none';
    startTrim?: number;
    endTrim?: number;
}

export function editArgs({
    audioAction,
    startTrim,
    endTrim,
}: IEditArgs): Array<string> {
    const args: Array<string> = [];

    if (typeof startTrim !== 'undefined' && startTrim > 0) {
        const timeStart = secondToHHMMSS(startTrim);
        args.push('-ss', timeStart);
    }
    if (typeof endTrim !== 'undefined' && endTrim > 0) {
        const secondStartTrim = typeof startTrim !== 'undefined' && startTrim > 0 ? startTrim : 0;
        const timeEnd = secondToHHMMSS(endTrim - secondStartTrim);
        args.push('-t', timeEnd);
    }

    if (audioAction === 'add') args.push('-map', '0', '-map', '1:a');
    else if (audioAction === 'remove') args.push('-an');

    args.push('-c', 'copy');

    return args;
}

export function mergeArgs(): Array<string> {
    return [
        '-i',
        'srcVideo',
        '-i',
        'srcAudio',
        '-map',
        '0',
        '-map',
        '1:a',
        '-c:v',
        'copy',
    ];
}
